import { Icon } from "@atoms";
import { cn, getWorkdayStatusIconName } from "@utils";
import { CancellableWorkdayStatus } from "@lib/store/src/data/timeslots/apiTypes";

interface Props {
  status: CancellableWorkdayStatus | undefined;
  className?: string;
}

export const WorkdayIcon = ({ status, className }: Props) => {
  return (
    <div className={cn("flex items-center justify-center size-12 rounded-md", className)}>
      <Icon
        icon={getWorkdayStatusIconName(status)}
        color="currentColor"
        className="size-5"
      />
    </div>
  );
};
